import React, { useContext } from "react";

// AssetDownloadContext
import AssetDownloadContext from "core/AssetDownload/Context";
import {
    setIsReadyForDownload,
    setAttributionIsVisible
} from "core/AssetDownload/Context/actions";

// styles
import { BackLinkStyled } from "./styles";

// components
import Link from "core/Link";

const BackLink = () => {
    const {
        state: { purchaseType },
        dispatch
    } = useContext(AssetDownloadContext);

    if (purchaseType.id !== 2) {
        return null;
    }

    const onClick = () => {
        dispatch(setIsReadyForDownload(false));
        dispatch(setAttributionIsVisible(false));
    };

    return (
        <BackLinkStyled>
            <Link
                onClick={onClick}
                styleType="primary"
                size="sm"
                isButton
                disableVisitedStyle
                darkMode
            >
                Back to all purchase options
            </Link>
        </BackLinkStyled>
    );
};

export default BackLink;
